<template>
  <transition name="zoom">
    <div>
      <el-card v-loading="loading"
               class="page-box detail-box settle"
               shadow="never">
        <div slot="header" class="clearfix">
          <div class="title">投诉信息</div>
          <span class="close"  @click="$emit('order-view','order-list')">
          <icon-svg iconClass="close-small"></icon-svg>
        </span>
        </div>
        <div class="order-info">
          <el-form
            :model="form"
            :rules="rules"
            ref="form"
            label-width="100px"
          >

            <el-form-item
              prop="content"
              label="投诉信息"
              class="ipt-textarea"
            >
              <el-input type="textarea" v-model="form.content" placeholder="请填写投诉信息" resize="none"></el-input>
            </el-form-item>
            <el-form-item  class="ipt-textarea"
                           prop="imgs"
                           label="投诉照片"
            >
              <el-upload class="zs-upload"
                         :action="appApi"
                         list-type="picture-card"
                         :file-list="filelist"
                         :on-success="uploadSuccessZS"
                         :on-preview="handlePictureCardPreview"
                         :on-exceed="handleexceed"
                         :on-remove="handleRemove" :limit=5>
                <i class="el-icon-plus"></i>
              </el-upload>
              <el-dialog :visible.sync="dialogVisible" :modal="false">
                <img width="100%" :src="dialogImageUrl" alt="">
              </el-dialog>
            </el-form-item>
          </el-form>
        </div>
        <div class="close-win">
          <el-button style="width: 120px" @click="$emit('order-view','order-list')">关闭</el-button>
          <el-button type="primary"  style="width: 120px" @click="submitForm">投诉</el-button>
        </div>
      </el-card>
    </div>
  </transition>

</template>

<script>
import {order, dict} from '@/api'
import {validImage, toolbarOptions, quillUploadSuccess} from '@/utils'

export default {
  name: 'ComplaintOrder',
  components: {},
  watch: {
  },
  computed: {

  },
  data () {
    return {
      appApi: process.env.VUE_APP_API + '/upload/image/single/',
      submitting: false,
      loading: false,
      param: '',
      imageUrl: '',
      dialogVisible: false,
      dialogImageUrl: '', // 预览
      listImgUrl: [], // 存储上传的图片
      filelist: [], // 展示上传的图片
      form: {
        imgs: '',
        createUser: this.$store.state.user.userId,
        orderFormId: '',
        content: ''
      },
      rules: {
        content: [
          {required: true, message: '请填写投诉内容', trigger: 'blur'},
          {min: 1, max: 32, message: '长度在 1 到 1000 个字符', trigger: 'blur'}
        ]
      }
    }
  },
  methods: {
    submitForm () {
      this.$refs['form'].validate((valid) => {
        if (valid) {
          this.addOrderComplain()
        } else {
          return false
        }
      })
    },
    async addOrderComplain () {
      this.loading = true
      this.form.orderFormId = this.param
      this.form.imgs = this.listImgUrl.toString()
      let {code, msg} = await order.addOrderComplain(this.form)
      this.loading = false
      this.dialogFormVisible = true
      if (code !== 0) {
        this.$message(msg || '网络错误，请稍后重试')
      } else {
        this.$message({
          message: '投诉成功！',
          type: 'success'
        })
        this.$emit('order-view', 'order-list', 'all')
      }
    },
    changeEvent (value) {
      this.param = value
    },
    uploadSuccess (res, file) {
      this.loading = false
      this.imageUrl = process.env.VUE_APP_IMG + res.data
      this.form.headImg = res.data
    },
    uploadError () {
      this.loading = false
      this.$message({type: 'info', message: '插入图片失败，请稍后重试'})
    },
    beforeUpload (file) {
      let validImage1 = validImage(file, 500)
      this.loading = validImage1
      return validImage1
    },
    uploadSuccessZS (res, file) {
      this.loading = false
      this.dialogImageUrl = process.env.VUE_APP_IMG + res.data
      this.listImgUrl.splice(0, 0, res.data)
    },
    handleRemove (file, fileList) {
      if (file.name) {
        let array = this.listImgUrl
        this.listImgUrl.splice(array.findIndex(v => v === file.name), 1)
      } else {
        let array = this.listImgUrl
        this.listImgUrl.splice(array.findIndex(v => v === file.response.data), 1)
      }
    },
    handlePictureCardPreview (file) {
      this.dialogImageUrl = file.url
      this.dialogVisible = true
    },
    handleexceed (file, fileList) {
      this.$message({type: 'error', message: '最多上传5张图片'})
    }
  }
}
</script>

<style lang="scss" scoped>
  .settle {
    min-height: calc(100vh - 200px);
  }
  .money {
    font-size: 24px;
    color: $main-color;
  }
  .el-input {
    width: 240px;
  }
  .page-content {
    min-width: 1000px;
  }
  .el-card {
    /*position: absolute;*/
    top: 20px;
    right: 20px;
    left: 20px;
    z-index: 2;
    margin-bottom: 0;
    background-color: #fff;
    /deep/ .el-card__header {
      padding: 0 0 10px 0;
      .title {
        font-size: 16px;
        font-weight: 500;
      }
    }
    .close {
      margin-top: -30px;
      float: right;
      .svg-icon {
        width: 2em;
        height: 2em;
      }
    }
    /deep/ .el-card__body {
      padding: 0;
    }
    .order-info {
      margin-top: 10px;
      .title {
        margin: 20px 0 10px 0;
        font-size: 16px;
        padding-bottom: 10px;
        border-bottom:1px solid #ebeef5;
      }
      .title-no {
        margin: 20px 0 10px 0;
        font-size: 16px;
        padding-bottom: 10px;
      }
      .content {
        margin: 10px 50px 0 0;
        font-size: 14px;
        color: $info;
        display: inline-block;
        .content-info {
          display: inline;
        }
      }
      .content-long {
        margin: 10px 50px 0 0;
        font-size: 14px;
        color: $info;
        .content-info {
          display: inline;
        }
      }
      .user-amount {
        width: 100%;
        height: 150px;
        .user-info {
          float: left;
          display: inline-block;
          margin-top: 20px;
          border: 1px solid #ebeef5;
          width: 300px;
          height: 110px;
          padding: 10px;
          .user-remaining {
            padding: 8px;
          }
          .member-left-text {
            margin: 8px;
            font-size: 13px;
            color: $info;
          }
          .unit {
            color: $info;
            font-size: 12px;
          }
          .member-left-money {
            margin: 10px 8px;
            font-size: 26px;
          }
          .member-left {
            float: left;
            width: 60%;
          }
          .member-right {
            float: right;
            width: 40%;
          }
        }
        .user-item {
          float: left;
          margin: 40px 20px 20px 20px;
          width: 67%;
          /*display: inline-block;*/
          .service-item {
            display: inline-block;
            color: $sidebar-text;
            border-radius: 6px;
            padding: 6px 24px;
            border: 1px solid #ebeef5;
            margin: 10px;
          }
        }
      }
      .el-table {
        margin-top: 0;
      }
    }
    .close-win {
      text-align: center;
    }
    .total-money {
      margin-top: 10px;
    }
  }
</style>
